import { render, staticRenderFns } from "./contentDetail.vue?vue&type=template&id=62d42790&scoped=true"
import script from "./contentDetail.vue?vue&type=script&lang=js"
export * from "./contentDetail.vue?vue&type=script&lang=js"
import style0 from "./contentDetail.vue?vue&type=style&index=0&id=62d42790&prod&lang=less&scoped=true"
import style1 from "./app.841a88aa.css?vue&type=style&index=1&id=62d42790&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d42790",
  null
  
)

export default component.exports